var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1603_31795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1668 3.8335H3.8335V42.1668H42.1668V3.8335Z",
    fill: "#0091D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8335 3.8335L13.414 13.4196L23.0002 3.8335H3.8335Z",
    fill: "#0091D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8335 3.8335V23.0002L13.414 13.4196L3.8335 3.8335Z",
    fill: "#009AD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 23.0002L13.4196 13.4141L3.8335 23.0002H23.0002Z",
    fill: "#0091D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 23.0002V3.8335L13.4194 13.414L23 23.0002Z",
    fill: "#0082C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 3.8335V23.0002L32.5805 13.4196L23 3.8335Z",
    fill: "#0071BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1667 23.0002L32.5861 13.4141L23 23.0002H42.1667Z",
    fill: "#004C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8335 23L13.414 32.5861L23.0002 23H3.8335Z",
    fill: "#0082C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8335 23V42.1667L13.414 32.5861L3.8335 23Z",
    fill: "#0071BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 42.1667L13.4196 32.5806L3.8335 42.1667H23.0002Z",
    fill: "#0066B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 42.1667V23L13.4194 32.5805L23 42.1667Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 23L32.5805 32.5861L42.1667 23H23Z",
    fill: "#1B3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 23V42.1667L32.5805 32.5861L23 23Z",
    fill: "#004C98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1667 42.1667L32.5861 32.5806L23 42.1667H42.1667Z",
    fill: "#1B3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.167 42.1667V23L32.5864 32.5805L42.167 42.1667Z",
    fill: "#1B3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 3.8335L32.5805 13.4196L42.1667 3.8335H23Z",
    fill: "#0066B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.167 23.0002V3.8335L32.5864 13.414L42.167 23.0002Z",
    fill: "#00529C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1669 27.7933L29.8931 16.1074L11.2695 34.7757L18.0616 41.5678L29.8931 29.9211L42.1669 42.1277V27.7933Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1603_31795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.3333,
    height: 38.3333,
    fill: "white",
    transform: "translate(3.8335 3.8335)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/전북-46.8122d2701f297a6baf4e626797d7d380.svg";
export { ForwardRef as ReactComponent };